import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
//import moment from '../moment/moment.min.js';
//npm install --save moment react-moment
import { format } from 'date-fns';
import $ from 'jquery';
import { saveAs } from "file-saver";
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const Renderform = () => {
const navigate = useNavigate();

let show = true, listener=false;
const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");	

//var boolFetchingSads=false;
const navSubmitvsaform = React.useRef();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

//let sectionsHtmrows=[];// this needs to be available for the useEffect
const [progress, setProgress] = useState({
perct:null
});


const navSubmitform = React.useRef();

const [tblvsalogs, setTblvsalogs] = useState([]);
const [arrcheckbox, setArrcheckbox] = useState([]);
const [dowait, setDowait] = useState({show: false});
const [dlwait, setDlwait] = useState({show:false});
const [form1, setForm1] = useState({action:""});

const [scans, setScans] = useState({dtviewed:''});
const [emplids, setEmplids] = useState([]);
/*use the first useEffect to load options, sectionnames, arrFields*/
const [formoptions, setFormoptions] = useState([]);
const [sectionnames, setSectionnames] = useState([]);
const [currsection, setCurrsection] = useState({index:null});
const [sectionsHtmrows, setSectionsHtmrows] = useState({htm:null});
const [city, setCity] = useState({name:"vouchers"});
const [cbvsalog, setCbvsalog] = useState({checked:""});


const [arrFields, setarrFields] = useState([]);//array of fields from db records
const [currsectionfields, setCurrsectionfields] = useState([]);//which fields in arrFields apply to current section
/*
currsectionfields is only used in the call to updatevsaapp
to say which fields in arrFields apply to current section
*/

const [formControls, setFormControls] = useState([]);//controls for each field
//vsaapp comes from db vsa record and will look like arrFields as a single Object with a col for each field
const [vsaapp, setVsaapp] = useState({});

const [selectedFiles, setSelectedFiles] = useState([]);


const [axiofl, setAxiofl] = useState({
selectedFile: null
});

//const [section, setSection] = useState({letter:'A',name:'',index:0});

const [tblsections, setTblsections] = useState([]);







const location = useLocation();


useEffect(() => {
/*
navigate("/vsavouchers",{state:{VSA_APP_ID:vsaapp.VSA_APP_ID}});
*/

document.title =   "APS Visa Form";	

//if (sessionStorage.getItem("VERIFY_DATE")==null && (sessionStorage.getItem("NUM_ROLES")==0||sessionStorage.getItem("NUM_ROLES")==null))
	//navigate('/login');
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if
	
if (formoptions.length<1){
	loadvsaform();
	setupCheckboxes();
	}//end if
	
 },[]);




useEffect(() => {
	/*
	after the fields are set, then initialize get the vsaapp
	, then set currsection.index, which triggers the writeformcontrols()
	*/
	let VSA_APP_ID="";
	if (location.state)
		if (location.state.VSA_APP_ID)
			VSA_APP_ID=location.state.VSA_APP_ID;
	
	if (arrFields.length>0){
		//if (location.state.VSA_APP_ID!=null && location.state.VSA_APP_ID!=undefined && location.state.VSA_APP_ID!='null' && location.state.VSA_APP_ID!='undefined')
		if (VSA_APP_ID!="")
			setVsaapp((prev)=>{
				return {...prev, VSA_APP_ID:location.state.VSA_APP_ID}
			});
		
		}//end if
		
	
 },[JSON.stringify(arrFields)]);



useEffect(() => {
	//when currsection.index changes call writeformcontrols()
	if (currsection.index!=null){
		if (currsection.index==10){
			setFormControls([]);
			if (document.getElementById('form1'))
				document.getElementById('form1').style.display='block';
			getvsavouchers();
			}
		else{
			if (document.getElementById('form1'))
					document.getElementById('form1').style.display='none';
			writeformcontrols();
			}
			
		}//end if
		
 },[currsection.index]);
 
useEffect(() => {
	
	adddateevent();
	
 },[JSON.stringify(formControls)]);


useEffect(() => {

console.log("currsection.index: "+currsection.index);
	
if (!document.getElementById("tblvsalogs"))
	return;

if (cbvsalog.checked=="checked"){
	document.getElementById("tblvsalogs").classList.remove("hidden");
	if (document.getElementById("tblvchrs"))
		if (!document.getElementById("tblvchrs").classList.contains("hidden"))
			document.getElementById("tblvchrs").classList.add("hidden");
	
	if (tblvsalogs.length==0)
		gettblvsalog();
	}
else {
	document.getElementById("tblvsalogs").classList.add("hidden");
	if (document.getElementById("tblvchrs"))
		if (document.getElementById("tblvchrs").classList.contains("hidden"))
			document.getElementById("tblvchrs").classList.remove("hidden");
	}

	
 },[cbvsalog.checked]);




 
 
useEffect(() => {
	
	/*
	after get the vsaapp
	, then set currsection.index, which triggers the writeformcontrols()
	*/
	if (vsaapp.VSA_APP_ID!=undefined && vsaapp.REF_NUM==undefined){
		//this the initial set VSA_APP_ID from location.state
		getvsaapp();
		}//end if
	else if (vsaapp.REF_NUM!=undefined && vsaapp.doSectionChange==true){
		console.log('vsaapp doSectionChange: '+vsaapp.doSectionChange);
		console.log('vsaapp useEffect: '+vsaapp.VSR_SUR_NAM);
		
		
		//let SCTN=(location.state.SCTN==undefined)?"":location.state.SCTN;
		let SCTN="";
		if (location.state)
			if (location.state.SCTN)
				SCTN=location.state.SCTN;
			
		if (SCTN=="")
			SCTN=(vsaapp.SUBMITTED_TO_CSC==null || vsaapp.SUBMITTED_TO_CSC=="")?"1":"16";
		
		let sectionIndex=0;
		if (SCTN!=''){
			for (var i=0; i<sectionnames.length; i++)
				if (sectionnames[i].letter==SCTN){
					sectionIndex=i;
					console.log('default to sectionIndex: '+sectionIndex);
					}//end if
			}//end if
		handleSectionChange(sectionIndex);//setCurrsection({index:0}
		}
	
 },[vsaapp]);


useEffect(() => {
	
	gettblvsalog();
		
 },[vsaapp.STATUS]);


/*
useEffect(() => {
	
	if (vsaapp.STATUS=="NEW" && (vsaapp.VISADECISIONDATE || scans.dtviewed))
		setForm1({action:"refuse"});
		
 },[vsaapp.VISADECISIONDATE, scans.dtviewed]);
*/


useEffect(() => {
	console.log("form1.action: "+form1.action);
	if (form1.action=="submitrefuse"){
		document.getElementById('form1').requestSubmit();
		setForm1({action:"refuse"});
		}

//
		
 },[form1.action]);

useEffect(() => {
	
	if (sectionnames.length>0){
		console.log('sectionsHtmrows.length: '+sectionsHtmrows.htm.length);
		setTblsections(sectionsHtmrows.htm);
		}//end if
	
 },[JSON.stringify(sectionnames)]);



function adddateevent(){
	
	  let dateInputs = document.querySelectorAll('[type="date"]');
var dateClipboard="";

dateInputs.forEach(el => {
/*
    el.addEventListener('copy', () => {
	console.log("copy detected.  el.value: "+el.value);
        dateClipboard = el.value;
        //alert("copied");
    });
*/

    el.addEventListener('paste', (e) => {
	  var clipboardData, pastedData;

  // Stop data actually being pasted into div
  e.stopPropagation();
  e.preventDefault();

  // Get pasted data via clipboard API
  clipboardData = e.clipboardData || window.clipboardData;
  pastedData = clipboardData.getData('Text');
	console.log("paste detected.  pastedData: "+pastedData);
	
        if(pastedData != ''){
		
           el.value  = pastedData; 
           //alert("pasted");
         }
    });
});	
	
}//end func

function aftergetvsaapp(res){

//let datas={};
let datas=vsaapp;
//datas['REF_NUM']=res[0].REF_NUM;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
	//setVsaapp(datas);


setVsaapp((prev)=>{
	return {...prev, doSectionChange:true, datas}
});

const AD_USER=sessionStorage.getItem("AD_USER")==null?"":sessionStorage.getItem("AD_USER");
if (AD_USER!="" && datas.SUBMITTED_TO_CSC!='')
	getdocsdlcount();
	
}//end func

async function getvsaapp(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID, username:sessionStorage.getItem("USERNAME")} )
  };		

 await fetch(resturl+'rarvsaform/getvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvsaapp(res) )
      .catch(err => console.log(err));

}//end func

async function loadvsaform(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

await fetch(resturl+'rarvsaform/loadvsaform',requestOptions)
      .then(res => res.json())
      .then(res => 	afterloadvsaform(res) )
      .catch(err => console.log(err));

}//end func


function afterloadvsaform(res){
/*
will try initialize all the below using the formload data
const [formoptions, setformoptions] = useState([]);
const [sectionnames, setSectionnames] = useState([{letter:'A',name:'INFORMATION ABOUT THE PERSON TO BE EMPLOYED'}]);
const [currsection, setCurrsection] = useState({index:0});
const [arrFields, setarrFields] = useState([]);//array of fields from db records
const [formControls, setFormControls] = useState([]);//controls for each field
const [vsaapp, setVsaapp] = useState();//transform arrFields into a single Object with a col for each field
*/
initializeformoptions(res[0].options);
initializesectionnames(res[0].sections);
setarrFields(res[0].fields);

}//end func


function initializesectionnames(res){
let temp=sectionnames;
let htmrows=[];
let rowcount=1;
res.map((col, index) => {
	const letter=col['SCTN_LETTER'];
	const shortname=col['SHORT_NAME'];
	const name=col['SCTN_NAME'];
	
	const trkey='tr_'+letter;
	const tdkey='td_'+letter;
	const rdkey='rd_'+letter;
	const pIndex=rowcount-1;//calling requires constant value for index
	const rdsection=<><input type='radio' name='rdsection' key={rdkey} id={rdkey} onClick={(e)=>{handleSectionChange(pIndex);}} /><label htmlFor={rdkey} className='hand'  >{shortname}</label></>;
	htmrows.push(<tr key={trkey} ><td  style={{"paddingTop":"12px"}} key={tdkey}  >{rdsection}</td></tr>);
	//if (rowcount>1)
		temp.push({letter:letter,name:name});
	rowcount++;
	});//end map

setSectionnames(temp);

setSectionsHtmrows((prev)=>{
	return {...prev, htm:htmrows}
});

//console.log('sectionsHtmrows.length: '+sectionsHtmrows.length);

}//end func

function initializeformoptions(res){
let temp=[];
res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	//the value of combo is integer in 2 cases: MPE_OCCUPATIONID and AGENCY_ID
	const val=(combo=='agencyid' || combo=='occupationid')? col['VAL']:opt;
	//console.log('afterfetchctrycodes nam: '+nam);
	
	temp.push({name:combo, options:<option key={key} value={val}  >{opt}</option>});
	
	});//end map
setFormoptions(temp);
}//end func

function writeformcontrols(){
	
//console.log('usearrFields sectionLetter: '+sectionLetter);

let tempFormControls=[];
let tempcurrsectionfields=[];

if (arrFields==null || arrFields==undefined || arrFields=='null' || arrFields=='undefined' || arrFields.error){
	console.log('will exit writeformcontrols for arrFields==null || arrFields==undefined .');
	return;
	}//end if
	
if (arrFields.length<1){
	console.log('will exit writeformcontrols for arrFields.length<1 ?');
	return;
	}//end if	
//else
	//console.log('writeformcontrols arrFields.length: '+arrFields.length);

let fileCount=0;
	
arrFields.map((col, index) => {
	const sctn=col['SCTN'];
	const fld=col['FLD'];
	const datafield=col['DATAFIELD'];
	let typ=col['TYP'];
	const rqd=col['RQD'];
	let comboplus='';
	if (typ=='combo+'){
		typ='combo';
		comboplus=<><a href='#' onClick={(e)=>{clickComboplus(e, fld);}} ><img src='img/add.png' height="18" border='0' /></a></>;
		}//end if
	
	
	if (sctn==sectionnames[currsection.index].letter){
		tempcurrsectionfields.push(index);
		const currfileCount=fileCount;
	//.replace('\r', '<br/>').replace('\n', '<br/>')
		const key="_key_"+index;
		
		const opt=col['OPT'];
		const elemId=col['FLD'];
		//const redstar = (datafield==1 && rqd==1)?<span style={{color:'red'}}>*&nbsp;</span>:<></>;
		const lbl=col['SLBL'];
		//(datafield==1 && rqd==1)?:<><span style={{color:'red'}}>*&nbsp;</span>{col['LBL']}</>:<>col['LBL']</>;
		//if (typ=='combo') {console.log('opt: '+opt);}
		
		let inputsize=20;
		if (opt!=null)
			inputsize=1*opt;
		
		let opts=[];
		

	//const checkboxes=getcheckboxes(opt);s
		if (typ.startsWith('combo'))
			for (var i=0; i<formoptions.length; i++)
				if (formoptions[i].name==opt)
					opts.push(formoptions[i].options);

		//console.log('afterfetchctrycodess nam: '+nam);
		if (typ=='textarea')
			tempFormControls.push(<div align='left' className="formcontrols" style={{"paddingTop":"0px"}} key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><textarea key={"textarea"+key} name={fld} id={elemId} onChange={(e)=>{handleChange(e, typ, rqd);}} autoComplete='off' onFocus={(e)=>{e.target.select();}} cols="50" rows="4" defaultValue={vsaapp[fld]} ></textarea></div>);
		else if (typ=='combo')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><select key={"combo"+key} name={fld}  id={elemId} title={vsaapp[fld]}   defaultValue={vsaapp[fld]}  onChange={(e)=>{handleChange(e, typ, rqd);}} style={{maxWidth:"400px"}} ><option value='' key={'opt'+key} ></option>{opts}</select>&nbsp;&nbsp;{comboplus}</div>);
		else if (typ=='sectionhead')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><p className="wpsectionhead" >{lbl}</p></div>);
		else if (typ=='msg')
			tempFormControls.push(<div align='center' className="formcontrols" key={"div"+key} ><p className="wpmsg" dangerouslySetInnerHTML={{__html: lbl}} ></p></div>);
		else if (typ=='date')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"input"+key} name={fld} id={elemId} defaultValue={vsaapp[fld]}  onChange={(e)=>{handleChange(e, typ, rqd);}} type='date' onFocus={(e)=>{e.target.select();}} /></div>);
		else if (typ=='file'){
			let filename='';
			if (fileCount==0)
				filename="scans.pdf";

			
			{/*
			if (fileCount==1){filename="sign.png"}
			if (fileCount==2){filename="scans.pdf"}
			defaultValue={vsaapp[fld]}
			*/}
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} style={{marginBottom:"8px"}} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"input"+key} name={fld} id={elemId}   onChange={(e)=>{selectedFilesChange(e, currfileCount, filename);}} type='file' onFocus={(e)=>{e.target.select();}} /><br/><a href={refurl+filename} target="_none" className="nodecor" >{vsaapp[fld]}</a></div>);
			fileCount++;
			}
		else if (typ=='checkbox')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} >{lbl}</label><br/>{opts}</div>);
		else{
			//default (typ=='text')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"text_input"+key} name={fld} id={elemId} defaultValue={vsaapp[fld]} size={inputsize}  onChange={(e)=>{handleChange(e, typ, rqd);}} type='text' autoComplete='off' onFocus={(e)=>{e.target.select();}} /></div>);
			}
		
	}//end if
	
	});//end map



//console.log('formoptions.length: '+formoptions.length);

setFormControls(tempFormControls);

setCurrsectionfields(tempcurrsectionfields);
/*
currsectionfields is only used in the call to updatevsaapp
to say which fields in arrFields apply to current section
*/
	

}//end func



function handleSectionChange(pIndex){
	
//console.log('sectionnames: '+JSON.stringify(sectionnames));
	
//verify the array of sections is loaded
console.log('handleSectionChange sectionnames.length: '+sectionnames.length);
console.log('handleSectionChange pIndex: '+pIndex);
//if (!pIndex<sectionnames.length)
//	pIndex=sectionnames.length-1;

const letter=sectionnames[pIndex].letter;
//const name=sectionnames[pIndex].name;
setCurrsection({index:pIndex});

//console.log('handleSectionChange letter: '+letter);

if (document.getElementById('rd_'+letter))
	document.getElementById('rd_'+letter).checked=true;

}//end funcs

function clickComboplus(e, fld){
e.preventDefault();	
const elem=document.getElementById(fld);
	const userOpt=prompt('Please enter your intended option:');
	if (userOpt){
		console.log('elem.selectedIndex: '+elem.selectedIndex);
		var opt = document.createElement('option');
		opt.value = userOpt;
		opt.innerHTML = userOpt;
		const len=elem.length;
		console.log('len: '+len);
		elem.appendChild(opt);
		elem.selectedIndex=len;
		}//end if
	else
		elem.selectedIndex=0;
	
}//end if

function testChange(e){
const {name, value}=e.target;	
	setVsaapp((prev) => {
	return {...prev, doSectionChange:false, [name]:value}
	});	
};


function handleChange(e, typ, rqd){
//console.log('handleChange nam: '+e.target.name);
//console.log('handleChange typ: '+typ);

const val=e.target.value;

const {name, value}=e.target;
//const value=(rawvalue==null)?'':rawvalue.trim();
/*
to do: implement validations:
(i) names are alpha only
(ii) money is numbers only
(iii) remove all not alpha-numeric other than -_', also check lengths of names and emails
*/
document.getElementById('btnsavechanges').style.visibility='visible';
if (document.getElementById('btnsubmitapp'))
	document.getElementById('btnsubmitapp').style.visibility='hidden';


	if (rqd==1 && document.getElementById('RQD_'+name)){
		console.log('RQD_'+name+' value: '+value);
		document.getElementById('RQD_'+name).style.color=(value=='')?'red':'blue';
		}
		

	setVsaapp((prev) => {
	return {...prev, doSectionChange:false, [name]:value}
	});


}//end func



async function getvsavouchers(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VCHR_TYPE:"V1", WPT_APP_ID:vsaapp.VSA_APP_ID} )
  };		

 await fetch(resturl+'rarwpform/getwptvouchers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvsavouchers(res) )
      .catch(err => console.log(err));

}//end func

function clickVouchers(e){
}



function openCity(evt, cityName) {
	console.log("openCity: "+cityName);
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

	if (evt)
		evt.currentTarget.className += " active";
	
	setCity({name:cityName});
	
}//end func

async function downloadDoc(e, docNo){
	e.preventDefault();
	e.target.style.visibility='hidden';
	const filename=docNo+".pdf";
	//const filename="RCP.pdf";
	
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( {filename: filename} )
  };		
//setTblvchrs([]);
 await fetch(customspremurl+'rarwptapp/getvchrpdffile',requestOptions)
     
      .then(data => 	afterdownloadDoc(data, e, filename) )
      .catch(err => console.log(err));	
	
	
}//end func

async function afterdownloadDoc(res, e, filename){
	e.target.style.visibility='visible';
	
	const blob = await res.blob();
	saveAs(blob, filename);
	
/*
const blob = await res.blob();
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
link.parentNode?.removeChild(link);	
*/
	
	// saveAs(data.getBlob(), filename);
}//end func



async function getvchrstate(e, docNo){
	//getvchrstate
	e.preventDefault();
e.target.style.visibility='hidden';

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo})
};		

await fetch(customspremurl+'rarwptapp/getvchrstate',requestOptions)
  .then(res => res.json())
  .then(res => 	aftergetvchrstate(res, e.target, docNo) )
  .catch(err => console.log(err));	
	
}//end func

function aftergetvchrstate(res, elem, docNo){
	elem.style.visibility='visible';
var DOC_STATE_DESC=null;
if (res.length)
	if (res.length==1)
		DOC_STATE_DESC=res[0].DOC_STATE_DESC;
	
if (DOC_STATE_DESC=='DISCARDED')
	cancelwpdoc(docNo);
else
	window.alert('First change document status from '+DOC_STATE_DESC+' to DISCARDED in SIGTAS');
	
}//end func

async function cancelwpdoc(docNo){


const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo, USERNAME:sessionStorage.getItem("USERNAME")})
};		

await fetch(resturl+'rarwpform/cancelwpdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	aftercancelwpdoc(res) )
  .catch(err => console.log(err));	
	
}//end func

function aftercancelwpdoc(res){
	let cancel_count=0;
	if (res.length)
		if (res.length==1)
			cancel_count=res[0].CANCEL_COUNT;
		
	if (cancel_count==0)
		showsnackbar("that failed.  please try again or contact admin");
	else{
		showsnackbar("cancellation complete on APS Portal only.<br/>SIGTAS is not automatically updated");
		getvsavouchers();
		}
		
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function aftergetvsavouchers(res){
	
let htmrows=[];

if (res.length==undefined){
	setFormControls(<><div align='center'>the vouchers table is currently empty </div></>);
	return;
	}//end if


	
	res.map((col, index) => {
		const docNo=col['DOC_NO'];
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		
		const key="tblvchrs_"+index;
		const htmrow=<tr key={key} >
					<td align="left" >{downloadLink}</td>
					<td align="left" >{col['AMOUNT']}</td>
					<td align="left" title={col['VCHR_COMMENT']} >{col['ACCT_DESCP_1']}</td>
					<td align="left" >{col['CHR_DATE_PAID']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		});//end map

let IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");
IRD_LOGIN_ID = (IRD_LOGIN_ID==undefined||IRD_LOGIN_ID==null)?"":IRD_LOGIN_ID;

const tblvchrs=<>
				<table align="center" className="customers" id="tblvchrs" >
				<thead>
				<tr>
				<th align="left" >Doc. #</th>
				<th align="left" >Amount</th>
				<th align="left" >Description</th>
				<th align="left" >Date Paid</th>
				</tr>
				</thead>
				<tbody>
					{htmrows}
				</tbody>
				</table>
	
				</>;
setFormControls(tblvchrs);

}//end func


function gettblvsalog(){
//const resturl=sessionStorage.getItem("RESTURL");
//console.log('resturl: '+resturl);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/gettblvsalog',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsalog(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblvsalog(res){
if (res.length==undefined)
	return;

	
console.log('aftergettblvsalog, res.length: '+res.length);

let htmrows=[];
let refNum=null, vstatus=null;

res.map((col, index) => {
	const appid=col['VSA_APP_ID'];
	const trkey='tr_'+appid;
	
	if (refNum==null){
		refNum=col['REF_NUM'];
		vstatus=col['STATUS'];
		
		}

const stamp="updated: "+col['STAMP'];		
	
	const htmrow=<tr key={trkey} >
	<td align='left' >{col['SEQ_NO']}</td>
	<td align='left' title={stamp} >{col['DECISION_DATE']}</td>
	<td align='left' >{col['OLD_STATUS']}</td>
	<td align='left' >{col['NEW_STATUS']}</td>
	<td align='left' >{col['USERNAME']}</td>
	</tr>;
	
	htmrows.push(htmrow);
	
	
});

setTblvsalogs(htmrows);

	if (cbvsalog.checked=="")
		setCbvsalog({checked:"checked"});


}//end func






function toggleModalsmOld() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func


	
function toggleModalsm() {
/*
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
console.log('modalsm is null: '+(document.querySelector(".modalsm")==null));
*/	

if (document.querySelector(".modalsm")){
	const modalsm=document.querySelector(".modalsm");
	modalsm.classList.toggle("show-modalsm");
	/*
	a problem occurs sometimes when the popup window does not close when the x button is clicked
	below we log to check if modalsm still contains the show-modalsm class
	modalsm.classList.contains('show-modalsm'): false
	modalsm.classList.contains('show-modalsm'): true
	the event fires twice in the logs.  conclusion is theres overlap of button and window events when button is clicked
	Found that there was a second line of code calling closeButton.addEventListener("click", toggleModalsm);
	Problem solved after removing that second call to closeButton.addEventListener("click", toggleModalsm);
	console.log("modalsm.classList.contains('show-modalsm'): "+modalsm.classList.contains("show-modalsm"));
	*/
	
	
	
	if (modalsm.classList.contains("show-modalsm")){
		//when the popup opens, focus emailmsg and addEventListeners 
		document.getElementsByName('DEFER_MSG')[0].focus();
		//document.getElementsByName('DEFER_MSG')[0].value='';
		
		
		if (document.querySelector(".close-button")){
			const closeButton = document.querySelector(".close-button");
			if(!closeButton.classList.contains('attached-listener')){
				closeButton.classList.add('attached-listener');
				closeButton.addEventListener("click", toggleModalsm);
				window.addEventListener("click", windowOnClick);
				}//end if
			}//end if
	
		}//end if
	}//end if



}//end func

async function openScans(e) {
e.preventDefault();
//const fileName=;
const coverfilepath=vsaapp.REF_NUM+"/scans.pdf";
const params={
	filepath:coverfilepath
	, TBL: "VSA"
	, WPT_APP_ID: vsaapp.VSA_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")
	, FILENAME: "scans.pdf"
	, FLAG_DL: 1
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

	setDlwait({show:true});

  fetch(resturl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, vsaapp.REF_NUM+"_scans.pdf"))
      .catch(err => console.log(err));


}//end func


async function afteropenScans(res, fileName){

const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", fileName);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	
setDlwait({show:false});
//setScans({dtviewed:new Date()});
getdocsdlcount();
}//end func


function getdocsdlcount(){

const params={
	TBL: "VSA"
	, WPT_APP_ID:vsaapp.VSA_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")
	, FILENAME:"scans.pdf"
	, FLAG_DL:0
	} 

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params)
  };		

  fetch(resturl+'rarwpform/getdocsdlcount',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetdocsdlcount(res) )
      .catch(err => console.log(err));

}//end func

function aftergetdocsdlcount(res) {
	if (res.length!=undefined)
		setScans({dtviewed:res[0].STAMP});
}//end func


function writeCheckboxValue(isChecked, checkboxValue){

//showBtnsave();

/*
let strComments = document.getElementById("comboticksresult").value.trim();
console.log("strComments: "+strComments);

if (isChecked==true){
	if (strComments!="")
		strComments+="\r\n";

	strComments+=checkboxValue;
	}
else{
	strComments=strComments.replace("\r\n"+checkboxValue,"");
	strComments=strComments.replace(checkboxValue,"");
	strComments=strComments.replace("\r\n\r\n", "\r\n");
	}
*/


	const resultElem = document.getElementById("comboticksresult");
	const cbopts=document.getElementsByName("cbopts");
	console.log("setresult cbopts.length: "+cbopts.length);
	var result="";
	for (var i=0; i<cbopts.length; i++){
		
		if (cbopts[i].checked===true){
			if (result!="")
				result+="\r\n";
			
			result+=cbopts[i].value;
			}//end if
		
setVsaapp((prev)=>{
	return {...prev, DEFER_MSG:result}
	});
	//resultElem.value=result;
		
}//end for

//resultElem.value=result;

}//end func


function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

async function uploadfiles(){
	console.log('uploadfiles: '+selectedFiles.length);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 3 
router.post('/uploadfiles', upload.array('filesupload',3), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('VSA_APP_ID', vsaapp.VSA_APP_ID);
form.append('REF_NUM', vsaapp.REF_NUM);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
//let formfiles={foto:false,sign:false,scans:false};
let filenames={scans:''};
let scansFile=null;
let numfilesupload=0;
for (var i=0; i<selectedFiles.length; i++){
	const currfile=selectedFiles[i].file;
	const name=selectedFiles[i].name;
	//console.log('name: '+name);

	if (name=='scans.pdf'){
		scansFile=new File([currfile], 'scans.pdf');
		filenames.scans=currfile.name;
		numfilesupload++;
		//formfiles.scans=true;
		}//end if
	
	}//end for

//form.append('filenames', filenames);
form.append('VSR_SCANS', filenames.scans);

if (scansFile!=null)	{form.append('filesupload', scansFile);}

//const url=resturl+'rarwpform/upload'+numfilesupload+'file';
//console.log('uploadfile url: '+url)
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(resturl+'rarvsaform/uploadfile', form, request_config)
.then(res => afteruploadfiles(res.data, filenames.foto, filenames.scans));

{/*
	function cb(res){
		console.log('cb: '+JSON.stringify(cb));
	}

*/}

	
}//end func

function afteruploadfiles(data, fotofilename, scansfilename){
	console.log('afteruploadfiles: '+JSON.stringify(data));
	if (document.getElementById('btnsubmitapp'))
		document.getElementById('btnsubmitapp').style.visibility='visible';
	
	//showsnackbar('record update complete');
	setDowait({show:false});

	if (scansfilename!='' && data.pdfPageCount<3)
		alert("The scanned documents in pdf format did not meet the requirement; it should be 3 pages or more");
	
}//end func


async function resetvsastanew(e){
e.preventDefault();	

	const confirmed=window.confirm("reset STATUS to new?");
	if (!confirmed){
		return;
		}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID}  )
  };

	setDowait({show:true});
	
 await fetch(resturl+'rarvsaform/resetvsastanew',requestOptions)
      .then(res => res.json())
      .then(res => 	afterresetvsastanew(res) )
      .catch(err => console.log(err));

}//end func

function afterresetvsastanew(res){
	setDowait({show:false});
if (res.length){
	showsnackbar("reset done!");
	getvsaapp();
	}
}//end func

async function overturnvsaapp(){
	
	const confirmed=window.confirm("This visa application was overturned by the Minister? please confirm");
	if (!confirmed){
		return;
		}
	//new Date().toISOString().slice(0, 10)
	const vsaapplog={
		VSA_APP_ID:vsaapp.VSA_APP_ID
		,DECISION_DATE:vsaapp.MINISTERDECISIONDATE
		,STATUS:"OVERTURN BY MINISTER"
		,NOTE:""
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME: sessionStorage.getItem("USERNAME"), vsaapplog:vsaapplog}  )
  };

	setDowait({show:true});
	
 await fetch(resturl+'rarvsaform/updatevsastatus',requestOptions)
      .then(res => res.json())
      .then(res => 	afteroverturnvsaapp(res) )
      .catch(err => console.log(err));	
}//end func

function afteroverturnvsaapp(res){
	
	setDowait({show:false});
	
/*
	if (cbvsalog.checked=="")
		setCbvsalog({checked:"checked"});
	else
		gettblvsalog();

*/	
	setVsaapp((prev)=>{
		return {...prev, STATUS:"OVERTURN BY MINISTER"}
		});
}//end func

async function updatevsaapp(e){
	

document.getElementById('btnsavechanges').style.visibility='hidden';


console.log('updatevsaapp SUBMITTED_TO_CSC: '+vsaapp.SUBMITTED_TO_CSC);
if (vsaapp.SUBMITTED_TO_CSC!=null && vsaapp.SUBMITTED_TO_CSC!=''){
	alert('changes cannot be saved because this application was submitted already!');
	return;
	}//end if
const sectionLetter=sectionnames[currsection.index].letter;

if (sectionLetter=='15'){
	uploadfiles();
	return;
	}//end if

let temp=[];
for (var i=0; i<currsectionfields.length; i++){
	const x=currsectionfields[i];
	const currField=arrFields[x];
	temp.push({
		FLD:currField.FLD
		,TYP:currField.TYP
		,RQD:currField.RQD
		,DATA:vsaapp[currField.FLD]
	});
	}//end for

let params={
	VSA_APP_ID:vsaapp.VSA_APP_ID
	, USERNAME:sessionStorage.getItem("USERNAME")
	, SCTN:sectionLetter
	, arrFields:temp
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params  )
  };

	setDowait({show:true});
	
 await fetch(resturl+'rarvsaform/updatevsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatevsaapp(res) )
      .catch(err => console.log(err));
}//end func

function afterupdatevsaapp(res){
	
navSubmitvsaform.current?.click();
//setDowait({show: false});
	
}//end func	


async function approvevsaapp(e){
const conf=window.confirm('Approve this application?');
if (!conf)
	return;
const params={
	VSA_APP_ID:vsaapp.VSA_APP_ID
	, STATUS:"APPROVED"
	, DECISION_DATE:vsaapp.VISADECISIONDATE
	, NOTE: ""
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), vsaapplog:params}  )
  };

	e.target.style.visibility='hidden';
	
 await fetch(resturl+'rarvsaform/updatevsastatus',requestOptions)
      .then(res => res.json())
      .then(res => 	afterapprovevsaapp(e, res) )
      .catch(err => console.log(err));
}//end func	

function afterapprovevsaapp(e, res){
	e.target.style.visibility='visible';
	console.log("afterapprovevsaapp res.length: "+res.length);
	if (res.length)
		if (res.length==1)
			setVsaapp((prev)=>{
				return {...prev, STATUS:res[0].STATUS}
			})
}//end func	

async function emailrefuseletter(e){
e.preventDefault();	

const conf=window.confirm('the refuse letter will be sent by email right away.  are you sure?');
if (!conf)
	return;

const nowstamp=format(new Date(), 'dd.MMMM.yyyy h.mm.ss');//yyyy/MM/dd kk:mm:ss
const fileName="Visa_Refuse_Letter_"+nowstamp;
//const fileName="visarefuseletter";
const vsaapplog={
	VSA_APP_ID:vsaapp.VSA_APP_ID
	,STATUS:"REFUSED"
	,DECISION_DATE:vsaapp.VISADECISIONDATE
	,NOTE:""
};

const params={
	 USERNAME:sessionStorage.getItem("AD_USER")
	, VSA_APP_ID:vsaapp.VSA_APP_ID
	, DEFER_MSG:vsaapp.DEFER_MSG
	, FILENAME: fileName
	, vsaapplog:vsaapplog
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params  )
  };
toggleModalsm();
	setDowait({show:true});
	
 await fetch(resturl+'rarvsaform/emailrefuseletter',requestOptions)
      .then(res => 	afteremailrefuseletter(res, fileName, e) )
      .catch(err => console.log(err));
}//end func

async function afteremailrefuseletter(res, fileName, e){
	
	setDowait({show:false});
	const blob = await res.blob();
	saveAs(blob, fileName+".docx");
	if (e.target)
		e.target.style.visibility='visible';	
	
	setVsaapp((prev)=>{
		return {...prev, STATUS:"REFUSED"}
		});	
}//end func
	
function showCheckboxes(flag) {
	let checkboxes = document.getElementById("checkBoxes");

if (flag!=null)
	show=flag;

	if (show) {
		if (document.getElementById("btnhidecheckboxes").classList.contains("hidden"))
			document.getElementById("btnhidecheckboxes").classList.remove("hidden");
const deferMsg=vsaapp.DEFER_MSG;
if (deferMsg!=""){
	const conf=window.confirm("The current message will be discarded.  continue?");
	if (conf)
		setVsaapp((prev)=>{
			return {...prev, DEFER_MSG:""}
			});
	else
		return;
	}//end if

/*
		if (document.getElementById('comboticksresult').value.trim()!=""){
			alert('This only works when the comment is empty.\r\nremove the comment if you want to proceed.');
			return;
			}//end if

*/		
		
		
		checkboxes.style.display = "block";
		show = false;
	} else {
			if (!document.getElementById("btnhidecheckboxes").classList.contains("hidden"))
				document.getElementById("btnhidecheckboxes").classList.add("hidden");

		checkboxes.style.display = "none";
		show = true;
		var i=0, len=document.getElementsByName("cbopts").length;
		for (var i=0; i<len; i++){
			document.getElementsByName("cbopts")[i].checked=false;
			}
		}//end else

	if (document.getElementById("btnclosecb"))
		document.getElementById("btnclosecb").style.visibility=(show==true)?'hidden':'visible';

	
	if (listener==false){

		window.addEventListener("click", windowOnClick);
		listener=true;


		}//end if

			
}//end func
		
	
	
function setupCheckboxes(){
// You have not satisfied the Department/Director of immigration that the applicant will leave the Turks and Caicos Islands at the end of your stay as a visitor. 	
//The Immigration Department is not satisfied that you have funds including income or assets to carry out you stated purpose or to remain yourself in the Turks 
const lsItem=" Appeal submitted after the 14 days period."+
", The Applicant's Police Record is missing."+
", The Applicant's Passport has expired."+
", Insufficient Funds."+
", The Applicant's name appears on the stop list of the Turks and Caicos Islands. Section 92 of the Immigration Ordinance."+
", You have not satisfied the Department/Director of immigration that the applicant will leave the Turks and Caicos Islands at the end of your stay as a visitor.";

const arrItem=lsItem.split(",");

let temparrcheckbox=[];

for (var i=0; i<arrItem.length; i++){
	const item=arrItem[i].trim();;
	const checkboxId="checkboxId_"+i;
	const key="checkboxId_"+i+"_label";
	
	temparrcheckbox.push(
			<label htmlFor={checkboxId} key={key} >
			<input type="checkbox" id={checkboxId} name="cbopts" defaultValue={item} onClick={ (e)=>{ writeCheckboxValue(e.target.checked, item); } } />
			{item}
			</label>	
	);
	}//end for
	
setArrcheckbox(temparrcheckbox);

document.getElementById("checkBoxes").style.display = "none";

}//end func

function clickCbvsalog(e){
	
	//const cityName=e.target.checked==true?"vsalog":"vouchers"
	const checked=e.target.checked==true?"checked":"";
	
	setCbvsalog({checked:checked});
	//
	
	//openCity(null, cityName);
}//end func


function handleSmipleChange(e){

const {name, value}=e.target;

setVsaapp((prev)=>{
	return {...prev, [name]:value}
});

}//end func


function handledefermsgChange(e){
showCheckboxes(false);
const {name, value}=e.target;

setVsaapp((prev)=>{
	return {...prev, [name]:value}
});

}//end func

function selectedFilesChange(event, index, filename){
//console.log('selectedFilesChange event.target.files.length: '+event.target.files.length);
//console.log('selectedFilesChange index: '+index);

const i=selectedFiles.length;
console.log('selectedFiles.length: '+i);
let temp=selectedFiles;
temp[i]={file:event.target.files[0], name:filename};
//temp[index]=event.target.files[0]
setSelectedFiles(temp);
if (document.getElementById('btnsavechanges'))
	document.getElementById('btnsavechanges').style.visibility='visible';

if (document.getElementById('btnsubmitapp'))
	document.getElementById('btnsubmitapp').style.visibility='hidden';

}//end func

		
function cleardefermsg(e){
e.preventDefault();
const conf=window.confirm("clear the message?");
if (!conf)
	return;

setVsaapp((prev)=>{
	return {...prev, DEFER_MSG:""}
})
}//end func
		
function submitform1(e){
e.preventDefault();
console.log("submitform1 form1.action: "+form1.action);
if (form1.action=="refuse" || form1.action=="submitrefuse"){
	setForm1({action:"refuse"});
	toggleModalsm();
	}
if (form1.action=="approve"){
	approvevsaapp(e);
	//navigate("/vsavouchers",{state:state});
	}
if (form1.action=="vouchers"){
	const state={VSA_APP_ID:vsaapp.VSA_APP_ID, REF_NUM:vsaapp.REF_NUM};
	navigate("/vsavouchers",{state:state});
	}
else if (form1.action=="overturn"){	
	overturnvsaapp();
	}
}//end func


const attr="val";
//const coverlink="http://localhost:3000/upload/"+vsaapp.REF_NUM+"/coverpage.pdf";
const refurl=sessionStorage.getItem("UPLOADURL")+vsaapp.REF_NUM+"/";

const username=(sessionStorage.getItem("USERNAME")=='null')?null:sessionStorage.getItem("USERNAME");
let AD_USER=sessionStorage.getItem("AD_USER");
AD_USER = (AD_USER==undefined||AD_USER==null)?"":AD_USER;
let IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");
IRD_LOGIN_ID = (IRD_LOGIN_ID==undefined||IRD_LOGIN_ID==null)?"":IRD_LOGIN_ID;

//const statusOk=vsaapp.STATUS=="REFUSED" || vsaapp.STATUS=="DEFERRED" || vsaapp.STATUS=="CANCELLED"?false:true;

let cbvsalogstate="";

  return (
    <>
	
<div key="divctnr" className="container" style={{"backgroundColor":"#F0F0F0", "marginBottom":"36px"}} >
  <div key="divsn1"  className="section snwidth1" >
  
    
  <fieldset className="fieldsetformside" >
 <legend style={{marginBottom:"9px"}} >Click Section Names</legend>
 
  <table className='tblsectionnames'  align='center' >
  <tbody>
	  {tblsections}
  </tbody>
  </table>
  </fieldset>
  {/*section 1*/}
  </div>

  <div key="divsn2" className="section snwidth2"  >
{/*sections :*/}
<table align='left' className="tblsectiontitle"  cellPadding='0' cellSpacing='0' >
<tbody>
<tr>
	<td align='left' >
	{/*
		excel file: <input type="file" onChange={onFileChange}  style={{"width":"80px", "height":"30px"}} />
		&nbsp;&nbsp;
		<button onClick={onFileUpload} >upload file</button>	
	*/}	

	</td>
</tr>
	{currsection.index!=null && sectionnames.length>0 &&
		<tr>
			<td align='left' >Section {sectionnames[currsection.index].letter}: {sectionnames[currsection.index].name}</td>
		</tr>
	}
</tbody>
</table>

<p style={{height:"6px"}}>&nbsp;</p>


	
		{AD_USER!="" && vsaapp.SUBMITTED_TO_CSC!='' && 
		<form method='POST' id='form1' name='form1' style={{display:"none"}} onSubmit={(e)=>{submitform1(e);}} >
		<table align='center' style={{marginBottom:"24px"}} >
		<tbody>
		<tr>
			<td align='center' colSpan='2' >
			{dlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{
			!dlwait.show && 
			<a href="#" onClick={(e)=>{openScans(e);}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see scanned documents</a> 
			}
			</td>
		</tr>
		<tr>
			<td align='right' >Date Documents Viewed:</td>
			<td align='left' ><input required defaultValue={scans.dtviewed} onChange={(e)=>{e.preventDefault();}} className="read-only" /></td>
		</tr>
		<tr>
		<td align="right" >Type of Visa Applied for:</td>
		<td align="left" >{vsaapp.VSA_TYP}</td>
		</tr>
		<tr>
		<td align="right" >Surety's First and Last Name:</td>
		<td align="left" >{vsaapp.STY_GVN_NAM+" "+vsaapp.STY_SUR_NAM}</td>
		</tr>
		<tr>
		<td align="right" >Visitor's First and Last Name:</td>
		<td align="left" >{vsaapp.VSR_GVN_NAM+" "+vsaapp.VSR_SUR_NAM}</td>
		</tr>
		<tr>
			<td align='center' colSpan="2" >
			
			{/*<input name="VSR_GVN_NAM" value={vsaapp.VSR_GVN_NAM} onChange={(e)=>{ testChange(e);  }}  />*/}
			
			<input id="cbvsalog" checked={cbvsalog.checked} type="checkbox" onClick={(e)=>{clickCbvsalog(e);}} onChange={(e)=>{}} /><label htmlFor="cbvsalog" className="hand" >view application status log</label>
			
			
			</td>
		</tr>
		<tr>
			<td align='right' >Application Status:</td>
			<td align='left' >{vsaapp.STATUS}</td>
		</tr>
		{
		vsaapp.STATUS=="NEW" && 	
		<tr>
			<td align='right' >Decision Date:</td>
			<td align='left' ><input type='date' required name='VISADECISIONDATE' value={vsaapp.VISADECISIONDATE} onChange={(e)=>{handledefermsgChange(e);}} /></td>
		</tr>
		}


		<tr>	
			<td align='right' >
			{
			vsaapp.STATUS=="NEW" && <a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); setForm1({action:"submitrefuse"});  }} ><img src="img/refuseapp.png" border="0" /> type a refuse message</a>
			}
			
			</td>
			<td align='left' >
			{IRD_LOGIN_ID!="" && vsaapp.STATUS=="NEW" && <button className='button'  onClick={(e)=>{setForm1({action:"approve"});}}  >approve visa application</button>}
			{IRD_LOGIN_ID!="" && vsaapp.STATUS=="APPROVED" && <button className='button'  onClick={(e)=>{setForm1({action:"vouchers"});}}  >add new payment vouchers</button>}
			{
				IRD_LOGIN_ID!="" && (vsaapp.STATUS=="DEFERRED" || vsaapp.STATUS=="REFUSED") && 
				<>
				<button className='button'  onClick={(e)=>{setForm1({action:"overturn"});}}  >overturn by minister</button>
				<br/><input name="MINISTERDECISIONDATE" type="date" required value={vsaapp.MINISTERDECISIONDATE} onChange={(e)=>{ handleSmipleChange(e); }} />
				</>
			}
			</td>
		</tr>
		</tbody>
		</table>
		</form>
		}
		
		{
		currsection.index==10 && 
		<table align='center' id="tblvsalogs"  className='customers hidden' style={{width:"100%"}} >
		<thead>
		<tr>
			<th>seq. no</th>
			<th>decision<br/>date</th>
			<th>old status</th>
			<th>new status</th>
			<th>updated<br/>by user</th>
		</tr>
		</thead>
		<tbody>
			{tblvsalogs}
		</tbody>
		</table>		
		}
		
	{formControls}
	{
	AD_USER=="ajones" && <>
	<br/>
	<div align="center" ><button className="button" onClick={(e)=>{resetvsastanew(e);}} >reset visa STATUS to NEW</button></div>
	</>
	}
	<br/>
	<table className="tblbuttons"  >
	<tbody>
	<tr>
	<td align='center' >
	<a href='#' className="nodecor" onClick={(e)=>{e.preventDefault();window.scrollTo(0, 0);}} ><img src='img/uparrow.png' title='scroll to page top' border='0' /> page top</a>
	</td>

	<td align='left' >
	{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && 
	<input type='button' className='button' value='save changes' id='btnsavechanges' onClick={(e)=>{updatevsaapp(e)}}  />
	}	
	</td>
	
	{vsaapp.SUBMITTED_TO_CSC=='' && <td align='left' >
	<input type='button' className='button' value='ready to submit application' id='btnsubmitapp' onClick={(e)=>{navSubmitvsaform.current?.click();}}   />
	</td>
	}
	
	{/*
	{vsaapp.SUBMITTED_TO_CSC!=null && username!=null && <td align='left' >
	<input type='button' className='button' value='ready to export application' id='btnexportapp' onClick={(e)=>{navExportform.current?.click();}}   />
	</td>
	}
	
	*/}	
	
	</tr>
	</tbody>
	</table>

  </div>

  <div key="divsn3" className="section snwidth3" >
  
  <fieldset className="fieldsetformside" >
 <legend style={{marginBottom:"9px"}} >Application {vsaapp.VSA_APP_ID} Info</legend>
	<table  align='center' >
 <tbody>
	<tr>
	<td align='left' colSpan="2"  >Ref #</td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{vsaapp.REF_NUM}
	</td>
	</tr>

	<tr>
	<td align='left' colSpan="2"  >Email</td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{vsaapp.EMAIL_TO}
	</td>
	</tr>


	<tr>
	<td align='left' colSpan="2" >Last Updates
	
			
			
	</td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{vsaapp.CHR_MODIFY_DATE}
	</td>
	</tr>
	{vsaapp.SUBMITTED_TO_CSC!=null && 
		<>
		<tr>
		<td align='left' colSpan="2" >
		{/*<a href="#" onClick={(e)=>{return openCover(e);}} target="_none" style={{textDecoration:"none"}} >Submitted</a>*/}
		Submitted
		</td>
		</tr>
		<tr>
		<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
		{vsaapp.CHR_SUBMITTED_TO_CSC}
		</td>
		</tr>
		</>
		}
	
	{vsaapp.SUBMITTED_TO_CSC==null && 
		<tr>
		<td align='center' colSpan="2" >
		
		
		
		
		</td>
		</tr>
		}
		
	<tr>
	<td>
	<a href='#' className="nodecor" onClick={(e)=>{e.preventDefault();window.scrollTo(0, document.body.scrollHeight);}} ><img src='img/downarrow.png' title='scroll to page bottom' border='0' /> page bottom</a>
	</td>
	</tr>
	</tbody>
	
	
	
	
	</table>
  </fieldset>
  </div>
</div>	

        <NavLink ref={navSubmitvsaform} to={"/submitvsaform"} style={{display:"none"}}
          state={{VSA_APP_ID:vsaapp.VSA_APP_ID}}  >submitvsaform</NavLink>




<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div align='left' id='modalsmtext' >

				<form id="deferform" onSubmit={(e)=>{emailrefuseletter(e);}} >
				<table style={{width:"90%"}} border="0" >
				<tbody>
				<tr>
					<td align="center">
					<button className="button" >email refuse letter to customer</button>
					</td>
				</tr>
				<tr>
					<td align="center">
					Enter refuse reason(s):
					</td>
				</tr>
				</tbody>
				</table>				
				
				<textarea name="DEFER_MSG" id="comboticksresult" required value={vsaapp.DEFER_MSG} onChange={(e)=>{handledefermsgChange(e);}} cols="70" rows="6" required  placeholder="select a reason from the list or type a reason here" ></textarea>
				</form>

		<div className="multipleSelection">
			<table align="center">
			<tbody>
			<tr>
			<td>
			<div className="selectBox" onClick={(e)=>{showCheckboxes(null);}} >
				<select  >
					<option>Preset Comments</option>
				</select>

				<div className="overSelect"></div>
			</div>
			</td>
			<td>
				&nbsp;<a href="#" id="btnhidecheckboxes" className="hidden" onClick={(e)=>{e.preventDefault(); showCheckboxes(false);}} >close list</a>
			</td>
			<td>
				&nbsp;<a href="#" title="clear message" onClick={(e)=>{cleardefermsg(e);}} ><img src="img/trash.png" border="0" /></a>
			</td>
			</tr>
			</tbody>
			</table>

		</div>
		
			<div id="checkBoxes" align='left' className="checkBoxesScrollbars" >
			{arrcheckbox}
			</div>
		
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>

    </>
  );
  


};


export default Renderform;